module.exports = __webpack_public_path__ + "static/img/8.c27ca17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/8.png
// module id = 38Xx
// module chunks = 0